import { render, staticRenderFns } from "./impostazioni.vue?vue&type=template&id=14dc865c&"
import script from "./impostazioni.vue.ts?vue&type=script&lang=ts&"
export * from "./impostazioni.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports